import React, { useEffect, useRef, useState } from 'react'
import {
  RouterProps,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'
import logo from '../logo.svg'
import { Helmet } from 'react-helmet-async'
import './SelectFiles.scss'
import store, {
  RootState,
  AppDispatch,
  useAppDispatch,
  methods,
  configSlice,
  folderSlice,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'

import { prompt, alert, snackbar, bindEvent } from '@saki-ui/core'
import { useTranslation } from 'react-i18next'
import { Debounce, deepCopy } from '@nyanyajs/utils'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { eventTarget } from '../store/config'
import FileListComponent from '../components/FileList'
import { DetailComponent } from '../components/Detail'
import SelectFileListHeaderComponent from '../components/SelectFileListHeader'
import { byteConvert, download, getLink, Query } from '../modules/methods'
import moment from 'moment'
import { FolderItem } from '@nyanyajs/utils/dist/saass'
import { storage } from '../store/storage'

const SelectFilesPage = ({ children }: RouterProps) => {
  const { t, i18n } = useTranslation('selectFilesPage')
  const dispatch = useDispatch<AppDispatch>()
  const [debounce] = useState(new Debounce())
  const { config, sso } = useSelector((state: RootState) => state)

  const location = useLocation()
  const [searchParams] = useSearchParams()

  const filtertype = searchParams.get('filtertype')
  const uploadRootPath = decodeURIComponent(
    searchParams.get('uploadRootPath') || ''
  )

  const parentPath: string = 'selectFiles'

  useEffect(() => {
    const wAny = window as any

    console.log(
      'SelectFilesModal file',
      location.search.includes('sakiAppPortal='),
      wAny?.sakiui?.appPortal,
      uploadRootPath
    )
    if (location.search.includes('sakiAppPortal=')) {
      wAny?.sakiui?.appPortal?.setAppInfo?.({
        title: t('pageTitle'),
        logoText: 'SF',
        url: window.location.href,
      })
      // wAny.loadSakiUI = () => {
      //   wAny?.sakiui?.appPortal?.setAppInfo?.({
      //     title: t('pageTitle'),
      //     logoText: 'SF',
      //     url: window.location.href,
      //   })
      // }
    }
  }, [i18n.language])

  useEffect(() => {
    dispatch(configSlice.actions.setDirPath([parentPath]))
  }, [])

  // useEffect(() => {
  //   if (filtertype === 'image') {
  //     dispatch(configSlice.actions.setViewType('LargeIcon'))
  //   }
  // }, [filtertype])

  return (
    <>
      <Helmet>
        <title>
          {t('pageTitle') +
            ' - ' +
            t('appTitle', {
              ns: 'common',
            })}
        </title>
      </Helmet>
      <div className={'selectfiles-page ' + config.deviceType}>
        <FileListComponent
          parentPath={parentPath}
          showDeleteTime={false}
          showFolderPath
          showPermissions
          filterFileType={
            filtertype === 'image' ? ['.jpg', '.jpeg', '.png'] : []
          }
        ></FileListComponent>
      </div>
    </>
  )
}

export default SelectFilesPage
